import React, { useState } from 'react';
import { Box, Paper, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Divider, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { useLocation } from 'react-router-dom';

const VideoConfirmationPage = () => {
  const location = useLocation();
  const firstName = location.state?.firstName || '';
  const greeting = firstName ? `Thanks, ${firstName}!` : 'Thank You!';
  const [openScheduleDialog, setOpenScheduleDialog] = useState(false);
  const [scheduleLoading, setScheduleLoading] = useState(false);

  return (
    <Box sx={{ 
        position: 'fixed',
        inset: 0,
        // zIndex: 1400,
        backgroundColor: 'rgba(255,255,255,0.96)',
        // backdropFilter: 'blur(990px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2
      }}>
      <Paper
        elevation={6}
        sx={{
          maxWidth: 760,
          width: '100%',
          p: { xs: 4, md: 6 },
          borderRadius: 4,
          textAlign: 'center',
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: '#fff',
        }}
      >
        <Box
          sx={{
            mx: 'auto',
            mb: 3,
            width: 72,
            height: 72,
            borderRadius: '50%',
            backgroundColor: '#32d93830',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CheckCircleOutlineOutlinedIcon sx={{ fontSize: 34, color: 'success.main' }} />
        </Box>

        <Typography variant="h3" fontWeight={700} gutterBottom>
          {greeting}
        </Typography>
        <Typography variant="h4" color="text.secondary" sx={{ mb: 2 }}>
          Your video is on its way.
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, px: { xs: 0, md: 6 }, textAlign: 'center', lineHeight: 1.8, marginTop: '30px' }}>
          We&apos;ve emailed you a link to download your video along with practical ideas for using AI avatars at your association.
        </Typography>
          <Divider sx={{width: '120px', marginTop: '50px', marginBottom: '25px', margin: 'auto'}}/>
        <Box sx={{ pt: 4 }}>
          <Typography variant="h4" fontWeight={700} gutterBottom>
            Let's Brainstorm Ideas for Your Association
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, px: { xs: 0, md: 8 }, lineHeight: 1.8, marginTop: '30px', textAlign: 'center' }}>
            A short conversation can help identify opportunities where AI avatars may save time, reduce costs, and support member communications, education, advocacy, certification programs, and events.
          </Typography>
          <Button
            variant="contained"
            size="large"
            sx={{
              textTransform: 'none',
              py: 1.8,
              px: 4,
              backgroundColor: '#D32F2F',
              '&:hover': {
                backgroundColor: '#B71C1C',
              },
            }}
            onClick={() => {
              setScheduleLoading(true);
              setOpenScheduleDialog(true);
            }}
          >
            Schedule a 15-Minute Call
          </Button>
          <Dialog
            open={openScheduleDialog}
            onClose={() => setOpenScheduleDialog(false)}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle sx={{ m: 0, p: 2 }}>
              Schedule a 15-Minute Call
              <IconButton
                aria-label="close"
                onClick={() => setOpenScheduleDialog(false)}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ p: 0, minHeight: 560, position: 'relative' }}>
              {scheduleLoading && (
                <Box
                  sx={{
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: 'rgba(255,255,255,0.85)',
                    zIndex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    gap: 2,
                  }}
                >
                  <CircularProgress />
                  <Typography variant="body1" color="text.secondary">
                    Loading calendar...
                  </Typography>
                </Box>
              )}
              <Box sx={{ width: '100%', height: '100%', minHeight: 560 }}>
                <iframe
                  title="Schedule a call"
                  src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ38FzGA8SJ1G9k2JHuhxI3cueNuXi9WgP1yt5WSdZek9nyQADo3EOMijpeNA9uDfNETxXMbI7fT?gv=true"
                  width="100%"
                  height="100%"
                  style={{ border: 'none', minHeight: 560 }}
                  onLoad={() => setScheduleLoading(false)}
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenScheduleDialog(false)}>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 4 }}>
          Association Studios
        </Typography>
      </Paper>
    </Box>
  );
};

export default VideoConfirmationPage;
